/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_Event_OverlapInputs */

const en_fix_event_overlap = /** @type {(inputs: Fix_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix Event Overlap`)
};

const fr_fix_event_overlap = /** @type {(inputs: Fix_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corriger le chevauchement`)
};

const de_fix_event_overlap = /** @type {(inputs: Fix_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisüberlappung beheben`)
};

const it_fix_event_overlap = /** @type {(inputs: Fix_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correggi sovrapposizione eventi`)
};

const ru_fix_event_overlap = /** @type {(inputs: Fix_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исправление наложения событий`)
};

const es_fix_event_overlap = /** @type {(inputs: Fix_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corregir la superposición de eventos`)
};

const zh_cn2_fix_event_overlap = /** @type {(inputs: Fix_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修复事件重叠`)
};

const ja_fix_event_overlap = /** @type {(inputs: Fix_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの重複を修正`)
};

const hi_fix_event_overlap = /** @type {(inputs: Fix_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ओवरलैप को ठीक करें`)
};

const pt_pt2_fix_event_overlap = /** @type {(inputs: Fix_Event_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrigir sobreposição de eventos`)
};

/**
* | output |
* | --- |
* | "Fix Event Overlap" |
*
* @param {Fix_Event_OverlapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const fix_event_overlap = /** @type {((inputs?: Fix_Event_OverlapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_Event_OverlapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_fix_event_overlap(inputs)
	if (locale === "de") return de_fix_event_overlap(inputs)
	if (locale === "it") return it_fix_event_overlap(inputs)
	if (locale === "ru") return ru_fix_event_overlap(inputs)
	if (locale === "es") return es_fix_event_overlap(inputs)
	if (locale === "zh-CN") return zh_cn2_fix_event_overlap(inputs)
	if (locale === "ja") return ja_fix_event_overlap(inputs)
	if (locale === "hi") return hi_fix_event_overlap(inputs)
	if (locale === "pt-PT") return pt_pt2_fix_event_overlap(inputs)
	return en_fix_event_overlap(inputs)
});